import React, { useEffect } from "react";
import flow from "../images/flow.jpg";
import ccd from "../images/ccd.jpg";
import fire from "../images/5ire.jpg";
import h4b from "../images/h4b.jpg";
// import h4b2 from "../images/h4b2.jpg";
import htf from "../images/htf.jpg";
import devx from "../images/devx.jpg";
import devx2 from "../images/devx2.JPG";
import tokyo from "../images/tokyo.jpg";
import click from "../images/click.png";
import Aos from "aos";
import "aos/dist/aos.css";

const Talks = () => {
  const TalksDescs = [
    {
      id: 1,
      src: tokyo,
      style: "",
      link: "https://www.linkedin.com/posts/varunxdoshi_i-was-invited-as-a-speaker-and-mentor-at-activity-7239505068234829824-p_Qf?utm_source=share&utm_medium=member_desktop",
    },
    {
      id: 2,
      src: devx2,
      style: "",
      link: "https://www.linkedin.com/posts/varunxdoshi_a-few-days-back-we-at-polygon-guild-kolkata-activity-7209559393338564608-GlkD?utm_source=share&utm_medium=member_desktop",
    },
    // {
    //   id: 2,
    //   src: h4b2,
    //   style: "",
    //   link: "https://www.linkedin.com/posts/varunxdoshi_i-had-an-amazing-opportunity-of-mentoring-activity-7216815799762583553-uYSV?utm_source=share&utm_medium=member_desktop",
    // },
    {
      id: 3,
      src: devx,
      style: "w-80",
      link: "https://www.linkedin.com/posts/varunxdoshi_it-was-an-absolute-honour-organizing-polygon-activity-7134190914855473152--ML5?utm_source=share&utm_medium=member_desktop",
    },
    {
      id: 4,
      src: htf,
      style: "",
      link: "https://www.linkedin.com/posts/varunxdoshi_community-hackthisfall-htfkolkata-activity-7081544812323094528-H7LB?utm_source=share&utm_medium=member_desktop",
    },
    {
      id: 5,
      src: h4b,
      style: "",
      link: "https://www.linkedin.com/posts/varunxdoshi_hackathon-hack4bengal-team-activity-7084754524149579776--eE-?utm_source=share&utm_medium=member_desktop",
    },
    {
      id: 6,
      src: fire,
      style: "",
      link: "https://www.linkedin.com/posts/varunxdoshi_web3-events-developer-activity-7063168352596238336-TP2z?utm_source=share&utm_medium=member_desktop",
    },
    {
      id: 7,
      src: ccd,
      style: "",
      link: "https://www.linkedin.com/posts/varunxdoshi_community-event-tech-activity-7061708176680714240-4D7q?utm_source=share&utm_medium=member_desktop",
    },
    {
      id: 8,
      src: flow,
      style: "",
      link: "https://www.linkedin.com/posts/varunxdoshi_blockchain-developer-nft-activity-7034408163814555648-RLhK?utm_source=share&utm_medium=member_desktop",
    },
  ];

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="overflow-hidden">
      <div name="talks" className="text-white h-100vh ">
        <div className="max-w-7xl h-full mx-auto flex flex-col justify-center items-center">
          <div data-aos="slide-up" className="py-8">
            <h1 className=" font-rubik font-normal text-3xl md:text-6xl text-center text-white border-b-2 border-[#b03016] mx-16 pb-2 mb-4">
              {" "}
              <span className="text-[#30BCED] font-medium">Talks</span> &{" "}
              <span className="text-[#30BCED] font-medium">Community</span>
            </h1>
          </div>

          <div
            data-aos="fade-left"
            className="overflow-hidden grid lg:grid-cols-3 grid-cols-2 gap-x-6 md:gap-x-16 gap-y-10 md:gap-y-12 text-center mb-12 pb-6 px-4 md:px-0"
          >
            {TalksDescs.map(({ id, src, style, link }) => (
              <div
                className={"key={id} text-gray-700  rounded-lg mx-auto" + style}
              >
                <div className=" shadow-lg shadow-black h-full  w-full text-[#F7F0F5] ">
                  <img className=" rounded-lg w-72" src={src} alt="/" />
                  <a href={link} target="_blank" rel="noreferrer" className="">
                    <img
                      className="relative w-12 bottom-4 left-[43%] rounded-full hover:scale-105"
                      src={click}
                      alt=""
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Talks;
